import {customElement} from "lit/decorators/custom-element.js";
import {PropertyValues} from "lit";
import {AbstractViewerComponent} from "./abstract-viewer.component";

@customElement(`ha-string-viewer`)
export class HaStringViewerComponent extends AbstractViewerComponent<string> {

    protected shouldUpdate(changedProperties: PropertyValues): boolean {
        return this.value != undefined && true && super.shouldUpdate(changedProperties);
    }

    protected render(): unknown {
        return (Array.isArray(this.value))
            ? this.value.flat().map(val => "" + val).join(", ")
            : "" + this.value;
    }
}